import React from 'react';
import cx from 'classnames';
import CountUp from 'react-countup';
import wrapStore from '@src/utils/wrap-store';
import FirstPageStore, { ACTIVITY_STATUS } from '@src/pages/main/components/first-page/store';
import Link from '@src/components/link';
import { $$tracker } from '@src/tracker';
import KvVideo from './components/kv-video';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import styles from './index.less';

const lang = getLanguageByPath();

const isShowDownloadBtn = link => {
  return link && link !== 'hidden';
};

/**
 * FirstPage
 * @param store {FirstPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FirstPage = ({ store }) => {
  store.use();
  const { layerData, platformBtnConfig, localData, $globalStore } = store;

  // 预约模式平台跳转按钮
  const PlatformBtn = ({ children, className, bg, leftHover, rightHover, ...props }) => {
    return (
      <Link className={cx(styles.platformBtn, className)} {...props}>
        <div className={styles.hoverGroup} style={{ backgroundImage: `url(${bg})` }}>
          <div data-name="左侧光影" className={styles.leftShodw}>
            <div data-name="bg1" className={styles.bg1} style={{ backgroundImage: `url(${leftHover[0]})` }} />
            <div data-name="bg2" className={styles.bg2} style={{ backgroundImage: `url(${leftHover[1]})` }} />
            <div data-name="bg3" className={styles.bg3} style={{ backgroundImage: `url(${leftHover[2]})` }} />
            <div data-name="bg4" className={styles.bg4} style={{ backgroundImage: `url(${leftHover[3]})` }} />
          </div>
          <div data-name="右侧光影" className={styles.rightShodw}>
            <div data-name="bg1" className={styles.bg1} style={{ backgroundImage: `url(${rightHover[0]})` }} />
            <div data-name="bg2" className={styles.bg2} style={{ backgroundImage: `url(${rightHover[1]})` }} />
            <div data-name="bg3" className={styles.bg3} style={{ backgroundImage: `url(${rightHover[2]})` }} />
            <div data-name="bg4" className={styles.bg4} style={{ backgroundImage: `url(${rightHover[3]})` }} />
          </div>
        </div>
        {children}
      </Link>
    );
  };

  const RenderSlogan = () => {
    return (
      <div className={styles.slogan} data-name="slogan">
        <img alt="" src={localData.slogan} />
      </div>
    );
  };

  // 预约下载按钮
  const RenderADBtn = () => {
    const isDownload = $globalStore.isDownloadStage;
    return (
      <div className={styles.renderAdBtn}>
        <div className={styles.rootWarp}>
          <div data-name="底层border" className={styles.basicBg} />
          <div data-name="顶层背景组" className={styles.topBgGroup}>
            <div datga-name="hover纹理背景叠加" className={styles.hoverTexture} />

            <div data-name="纹理背景" className={styles.texture} />
            <div data-name="按钮边框动画组" className={styles.btnBorderAnimGroup}>
              <div data-name="上" className={styles.topGroup}>
                <div className={styles.border} />
              </div>
              <div data-name="右" className={styles.rightGroup}>
                <div className={styles.border} />
              </div>
              <div data-name="下" className={styles.bottomGroup}>
                <div className={styles.childGroup}>
                  <img alt="" src={require('./images/main-btn/top-border.png')} className={styles.bottomBorder} />
                </div>
              </div>
              <div data-name="左" className={styles.leftGroup}>
                <div className={styles.childGroup}>
                  <img alt="" src={require('./images/main-btn/top-border.png')} className={styles.leftBorder} />
                </div>
              </div>
            </div>
            <div data-name="左侧光影组" className={styles.leftShadowGroup}>
              <div data-name="bg-1" className={styles.bg1} />
              <div data-name="bg-2" className={styles.bg2} />
              <div data-name="bg-3" className={styles.bg3} />
              <div data-name="bg-4" className={styles.bg4} />
              <div data-name="bg-5" className={styles.bg5} />
              <div className={styles.hoverGroup}>
                <div data-name="bg-1" className={styles.bgHover1} />
                <div data-name="bg-2" className={styles.bgHover2} />
                <div data-name="bg-3" className={styles.bgHover3} />
              </div>
            </div>
            <div data-name="右侧光影组" className={styles.rightShadowGroup}>
              <div data-name="bg-1" className={styles.bg1} />
              <div data-name="bg-2" className={styles.bg2} />
              <div data-name="bg-3" className={styles.bg3} />
              <div data-name="bg-4" className={styles.bg4} />
              <div data-name="bg-5" className={styles.bg5} />
              <div className={styles.hoverGroup}>
                <div data-name="bg-1" className={styles.bgHover1} />
                <div data-name="bg-2" className={styles.bgHover2} />
                <div data-name="bg-3" className={styles.bgHover3} />
              </div>
            </div>
            {/* <div data-name="英文装饰" className={styles.decoration}>
              <img alt="" className={styles.left} src={endlishDecoration} />
              <img alt="" className={styles.right} src={endlishDecoration} />
            </div> */}
            <div data-name="按钮内容" className={styles.btnContent}>
              {isDownload ? (
                <Link
                  onClick={() => {
                    $$tracker.clickHomeDownload();
                  }}
                  href={layerData.download_link}
                  className={cx(styles.contentBtn)}
                  data-name="下载按钮"
                >
                  {localData.downloadText}
                </Link>
              ) : (
                <Link
                  clickEffect="opacity"
                  className={cx(styles.contentBtn)}
                  data-name="立即预约"
                  onClick={() => {
                    $$tracker.clickHomeReserve();
                    store.onAppointment();
                  }}
                >
                  {localData.appointmentText}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 下载模式，平台logo按钮组模块
  const RenderPlatformLogo = () => {
    return (
      <div className={styles.downloadModeLogoGroup} data-name="下载模式平台logo">
        {isShowDownloadBtn(layerData.steam_link) ? (
          <Link
            href={layerData.steam_link}
            target={'_blank'}
            className="first-page-layer-3"
            data-name="steam"
            style={{ backgroundImage: `url(${localData.steam_logo})` }}
            onClick={() => {
              $$tracker.clickHomeSteam();
            }}
          />
        ) : null}
        {isShowDownloadBtn(layerData.xbox_link) ? (
          <Link
            href={layerData.xbox_link}
            target={'_blank'}
            className="first-page-layer-2"
            data-name="image"
            style={{ backgroundImage: `url(${localData.xbox_logo})` }}
            onClick={() => {
              $$tracker.clickHomeXbox();
            }}
          />
        ) : null}
        {isShowDownloadBtn(layerData.gpg_link) ? (
          <Link
            href={layerData.gpg_link}
            target={'_blank'}
            className={styles.platformGooglePlay}
            data-name="image"
            style={{ backgroundImage: `url(${localData.gpg_logo})` }}
            onClick={() => {
              $$tracker.clickHomeGPG();
            }}
          />
        ) : null}
      </div>
    );
  };

  // 预约模式，平台logo按钮组模块
  const RenderReservationBtnGroup = () => {
    return (
      <div data-name="预约模式下方平台按钮" className={styles.reservationBtnGroup}>
        <PlatformBtn
          href={layerData.steam_link}
          target={'_blank'}
          normalBg={require('./images/steam-yuyue.png')}
          hoverBg={require('./images/steam-yuyue-hover.png')}
          className={cx(styles.btn, styles.steam)}
          data-name="添加steam游戏愿望表单按钮"
          onClick={() => {
            $$tracker.clickHomeSteam();
          }}
          bg={platformBtnConfig.steam.bg}
          leftHover={platformBtnConfig.steam.leftHover}
          rightHover={platformBtnConfig.steam.rightHover}
        >
          <div className={styles.text}>
            <div className={styles.icon} />
            <div className={styles.btnText}>{localData.steamWishBtnText}</div>
          </div>
        </PlatformBtn>
        <PlatformBtn
          href={layerData.xbox_link}
          target={'_blank'}
          normalBg={require('./images/xbox-yuyue.png')}
          hoverBg={require('./images/xbox-yuyue-hover.png')}
          className={cx(styles.btn, styles.xbox)}
          data-name="添加steam游戏愿望表单按钮"
          onClick={() => {
            $$tracker.clickHomeXbox();
          }}
          bg={platformBtnConfig.xbox.bg}
          leftHover={platformBtnConfig.xbox.leftHover}
          rightHover={platformBtnConfig.xbox.rightHover}
        >
          <div className={cx(styles.text)}>
            <div className={styles.icon} />
            <div className={styles.btnText}>{localData.xboxWishBtnText}</div>
          </div>
        </PlatformBtn>
      </div>
    );
  };

  // 活动入口模块
  const RenderActivityEntry = () => {
    return (
      <div className={styles.activityEntry} data-name="活动入口">
        {store.activityList?.map(item => {
          return item.activity_state === ACTIVITY_STATUS.open ? (
            <Link
              key={item.title}
              target={'_blank'}
              href={item.activity_url}
              className="first-page-layer-6"
              data-name={item.title}
              onClick={() => {
                $$tracker.clickHomeSidebar(item.title);
              }}
            >
              <div
                className={styles.activityItemInner}
                style={{
                  backgroundImage: `url(${item.cover_pc})`
                }}
              />
            </Link>
          ) : (
            <React.Fragment key={item.title} />
          );
        })}
      </div>
    );
  };

  // 视频播放模块
  const RenderVideoPlay = () => {
    return (
      <div className={styles.videoPlay} onClick={store.onVideoPlay}>
        <div className={styles.videoPlayCover} style={{ backgroundImage: `url(${layerData.videoCover})` }} />
        <div className={styles.playIcon} />
      </div>
    );
  };

  const renderAppointmentCount = () => {
    return (
      <div className={styles.appointmentCount}>
        <div className={styles.label}>
          <span className={styles.text} style={{ backgroundImage: `url(${require(`./images/${lang}/text-appoinment-count.png`)})` }} />
        </div>
        {<CountUp key={store.appointmentCount} className={styles.count} start={0} end={store.appointmentCount} enableScrollSpy separator={','} />}
      </div>
    );
  };

  return (
    <div className={cx(styles.root)}>
      <KvVideo store={store.kvVideoStore} cover={localData.kv_url} src={localData.kvVideoLink} />
      <div className="first-page-root">
        {/* <RenderSlogan /> */}
        <div className={styles.btnWrapper}>
          <RenderADBtn />
          <RenderPlatformLogo />
          <img className={styles.activityTime} src={require(`./images/${lang}/activity-time.png`)} alt="" />
        </div>
        {/* {renderAppointmentCount()} */}
        {RenderActivityEntry()}
        <RenderVideoPlay />
      </div>
    </div>
  );
};

export default wrapStore(FirstPage, FirstPageStore);
